import {
	IsInt,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsPositive,
	IsString,
	MaxLength,
	ValidateIf,
} from 'class-validator';

export class CreateCompetitivePriceDto {
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	public price!: number;

	@IsNotEmpty()
	@IsString()
	public vendorName!: string;

	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	public clientId!: number;

	/**
	 * PD-17066 — the competitor picked from the list. When set, the server
	 * writes that competitor's name to `vendorName`, which stays for SM1 and
	 * the notifications.
	 */
	@IsOptional()
	@IsInt()
	@IsPositive()
	public competitorId?: number | null;

	@IsOptional()
	@ValidateIf((_object, value) => value != null)
	@IsString()
	@MaxLength(5000)
	public note?: string | null;
}

export class UpdateCompetitivePriceDto {
	@IsOptional()
	@IsNumber()
	@IsPositive()
	public price?: number;

	@IsOptional()
	@IsString()
	public vendorName?: string;

	/** PD-17066 — null clears the competitor; the typed name stays. */
	@IsOptional()
	@ValidateIf((_object, value) => value != null)
	@IsInt()
	@IsPositive()
	public competitorId?: number | null;

	@IsOptional()
	@ValidateIf((_object, value) => value != null)
	@IsString()
	@MaxLength(5000)
	public note?: string | null;
}

export class CompetitivePriceResponseDto {
	public _id!: number;
	public price!: number;
	public vendorName!: string;
	/** PD-17066 — the linked competitor, when one was picked or matched. */
	public competitorId?: number | null;
	public competitorName?: string | null;
	public note?: string | null;
	public fk_item__id!: number;
	public fk_client__id!: number;
	public _created_date!: Date;
	public _modified_date!: Date;
	public _creator_userId?: number | null;
	public creatorName?: string | null;
	public clientName?: string;
	public clientAddress1?: string | null;
	public clientCity?: string | null;
	public clientState?: string | null;
	public clientZip?: string | null;
	public itemDescription?: string;
	public itemExternalId?: string;
	public itemExternalId2?: string | null;
	public itemManufacturer?: string | null;
	public itemPrice?: number | null;
	public fileId?: number | null;
	public fileName?: string | null;
}
